import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse, toIsoDate } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  if (data.status === 'SUCCESS') {
    //console.log('dynamicRountingconfig', data.dynamicRountingconfig)
    return data
  } else {
    throw {
      message: data?.failureMessage,
      code: data?.failureCode,
    }
  }
}

const getReqData = ({ id, resetAfter, plannedDowntimeStartAt, plannedDowntimeEndAt, failureRate }: any) => {
  const reqData = {
    id,
    /* entity: {
      processingEntity: data?.processingEntity,
      status: data.status, //active/inactive
    },
    bankId: data.bankId,

    mode: data.mode, //optional
    method: {
      subType: data?.subType, // optional

      type: data?.type, // optional
    },
    card: {
      type: data?.cardType,
      scheme: data?.cardScheme,
    },*/
    metaData: {
      ...(resetAfter && { resetAfter }),
      ...(plannedDowntimeStartAt && { plannedDowntimeStartAt: toIsoDate(plannedDowntimeStartAt) }),
      ...(plannedDowntimeEndAt && { plannedDowntimeEndAt: toIsoDate(plannedDowntimeEndAt) }),
      ...(failureRate && { failureRate }),
    },
  }
  return reqData
}

const updateDynamicRouteConfig = (tokens: any, data: any) => {
  console.log('data=', data)
  const reqData = getReqData(data)
  console.log('reqData', reqData)
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.updateDynamicRouteConfig),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: reqData,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { updateDynamicRouteConfig }
